import { css } from 'lit-element';
/* @internal */
export const styles = css`::slotted(input){display:none !important}
`;
